import { motion, useReducedMotion } from 'framer-motion'
import { cn } from '@/utils/cn'
import { getDashboardVariants } from './dashboardMotion'

interface Tab {
  id: string
  label: string
  icon?: React.ReactNode
}

interface DashboardTabControlProps {
  tabs: Tab[]
  activeTab: string
  onChange: (id: string) => void
}

export function DashboardTabControl({ tabs, activeTab, onChange }: DashboardTabControlProps) {
  const reduced = useReducedMotion()
  const v = getDashboardVariants(reduced)

  return (
    <motion.div
      variants={v.tabBar}
      initial='hidden'
      animate='show'
      className='flex flex-row flex-nowrap items-center justify-start gap-1 bg-white/[0.03] p-1 rounded-xl border border-white/[0.06] overflow-x-auto no-scrollbar w-full max-w-full min-w-0'
      style={{ direction: 'ltr' }}
    >
      {tabs.map((tab) => (
        <motion.button
          key={tab.id}
          type='button'
          variants={v.tabBarItem}
          onClick={() => onChange(tab.id)}
          className={cn(
            'flex shrink-0 items-center gap-2 px-4 py-2.5 rounded-lg text-xs font-bold transition-colors whitespace-nowrap relative',
            activeTab === tab.id
              ? 'text-white'
              : 'text-text-muted hover:text-text-primary hover:bg-white/[0.04]',
          )}
        >
          {activeTab === tab.id && (
            <motion.div
              layoutId='dashboard-tab-bg'
              className='absolute inset-0 bg-accent rounded-lg shadow-[0_0_15px_rgba(var(--accent-rgb),0.3)]'
              transition={{ type: 'spring', bounce: 0.2, duration: 0.6 }}
            />
          )}
          <span className='relative z-10 flex items-center gap-2'>
            {tab.icon}
            {tab.label}
          </span>
        </motion.button>
      ))}
    </motion.div>
  )
}
